module.exports = __webpack_public_path__ + "static/media/cta-action-stat.20ae9db6.svg";